import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { FacebookPageAnalyticsPostsSortOrder } from '@anytag/graphql';

export const InfluencerFacebookPostsListSearchSchema = SearchSchema.create({
  sort: { field: FacebookPageAnalyticsPostsSortOrder },
  filter: {
    schema: z.object({
      name: SearchSchema.types.string(),
      keyword: SearchSchema.types.string()
    })
  }
});

export type InfluencerFacebookPostsListSearchType = z.infer<typeof InfluencerFacebookPostsListSearchSchema>;
